import * as React from 'react';
import { IGetVillageListResponseSchema } from '../../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { STATION_DISTANCES } from '../../../interfaces/filters';
import { getStationDistanceLabel } from '../../../utils/filters_helpers';
import { StationsSearch } from '../search';
import { trackPopupRailwayDistanceChanged, trackRailwayPopupOpened } from '../tracking';
import { TStationsHeaderProps } from './container';

import * as styles from './StationsHeader.css';
import { pick } from '../../../utils/pick';
import { Select } from '../../Select';

export class StationsHeader extends React.PureComponent<TStationsHeaderProps> {
  public componentDidMount() {
    this.props.search('');
    trackRailwayPopupOpened();
  }

  public componentWillUnmount() {
    this.props.search('');
  }

  public render() {
    const { stations, onSelectSuggest, search } = this.props;
    const { stationDistance } = stations;

    const options = STATION_DISTANCES.map(distance => {
      return {
        label: `${distance} км`,
        value: distance,
        disabled: this.isDistanceDisabled(distance),
      };
    });

    return (
      <div className={styles['container']}>
        <StationsSearch
          stations={stations}
          onInputChange={(value, trackNotFound) => search(value, stationDistance, trackNotFound)}
          onSelectSuggest={onSelectSuggest}
        />
        <Select
          withArrow
          options={options}
          value={stationDistance}
          onChange={this.onDistanceChange}
          text={getStationDistanceLabel(stationDistance)}
          disabled={STATION_DISTANCES.every(this.isDistanceDisabled)}
          buttonParams={{ fontWeight: 'normal', fullWidth: true }}
        />
      </div>
    );
  }

  private isDistanceDisabled = (value: number) =>
    this.stationData && !Object.values(this.stationData).some((x: number) => x <= value);

  private get stationData(): IGetVillageListResponseSchema['stationData'] {
    const {
      stations: { selectedStations },
      stationData,
    } = this.props;

    return selectedStations.length && stationData ? pick(stationData, selectedStations) : stationData;
  }

  private onDistanceChange = (stationDistance: number) => {
    this.props.onChangePopupStationDistance(stationDistance);
    trackPopupRailwayDistanceChanged();
  };
}
